<template>
  <div class="detail-iframe">
    <iframe
      v-if="url"
      id="iframe"
      class="iframe"
      :src="url"
      width="100%"
      :height="height"
    ></iframe>
    <div class="go-back" v-if="isClose">
      <img
        src="@/assets/images/poster-close.png"
        class="close"
        @click.stop="isClose = false"
        alt
      />
      <div class="go-back-btn" @click.stop="handleClick"></div>
    </div>
  </div>
</template>

<script>
import { fixDocbookUrl } from '@utils/fixDocbookUrl.js'
export default {
  data () {
    return {
      height: '500px',
      url: '',
      isClose: false,
      iframePointerEvents: 'none'
    }
  },
  created () { },
  mounted () {
    setTimeout(() => {
      if (document.querySelector('.detail-iframe')) {
        this.height =
          document.querySelector('.detail-iframe').getBoundingClientRect().height ||
          '800px'
      }
      let fixUrl = fixDocbookUrl(this.$route.query.url)
      // 判断是否是日程项目
      if (fixUrl.search('schedule.docbook') !== -1) {
        if (fixUrl.includes("?")) {
          this.url = `${fixUrl}&iframe=true`
        } else {
          this.url = `${fixUrl}?iframe=true`
        }
      } else {
        this.url = fixUrl
      }
      console.log(this.fixUrl, '--------ifarme-------')
      this.isClose = this.$route.query.isHome == 1
    }, 0)
  },
  methods: {
    handleClick (event) {
      // 处理点击事件
      console.log('goHome')
      this.$router.push({
        path: '/',
        query: {
          id: this.$route.query.id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.detail-iframe {
  position: relative;
}
.iframe {
  border: none;
  position: relative;
}

.go-back {
  position: fixed;
  right: 0.43rem;
  bottom: 8rem;
  z-index: 1000000;

  .close {
    position: absolute;
    right: -0.3rem;
    top: -0.45rem;
    width: 0.8rem;
    height: 0.8rem;
  }
  .go-back-btn {
    position: relative;
    width: 2rem;
    height: 2rem;
    background: url(~@/assets/images/goBack.png) no-repeat center/cover;
  }
}
</style>
